<div class="margin-x-2 mt-100" *ngIf="isReauthenticationRequired()">
    <sk-feedback [dismissible]="false" icon="warning" [subject]="'settings.O365.ACCOUNT_O365_BAD_STATE_AUTH_TITLE' | translate" type="danger">
        <span translate="settings.O365.ACCOUNT_O365_BAD_STATE_AUTH_MESSAGE"></span>
        <button [disabled]="!isCurrentUserAdmin()" sk-button translate="settings.O365.ACCOUNT_O365_BAD_STATE_REENABLE_BUTTON_TEXT" class="ml-100"
            (click)="openAuthFlowModal()"></button>
    </sk-feedback>
</div>
